import styled from 'react-emotion';
import { cx, css } from 'emotion';

export const Gotham = `'Gotham A', 'Gotham B', sans-serif;`;

export interface ButtonProps {
  color: string;
  text?: string;
  bottomColor?: string;
  textColor?: string;
  disabled?: boolean;
  centered?: boolean;
}

export const maxWidth = 260;
export const maxHeight = 40;

export const maxDimensions = css`
  max-height: ${maxHeight}px;
  max-width: ${maxWidth}px;
  height: 100vh;
  width: 100%;
`;

export const content = css`
  display: block;
  ${maxDimensions};
  &:hover {
    cursor: pointer;
  }
  margin: 15px auto;
`;

export const SpanContent = styled('span')`
  display: block;
  ${maxDimensions};
  &:hover {
    cursor: pointer;
  }
  margin: ${(props: { centered?: boolean }) =>
    props.centered ? '15px auto' : '15px'};
`;

export const getLinkClass = (disabled: boolean | undefined) => {
  const cursor = css({
    cursor: disabled ? 'default !important' : 'pointer',
  });
  return cx(maxDimensions, cursor);
};

export const TopLayer = styled('span')`
  position: absolute;
  top: -4px;
  left: -4px;
  background-color: ${(props: ButtonProps) => props.color};
  text-align: center;
  ${maxDimensions};
  display: block;
`;

export const textAlignment = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  height: 100%;
  font-family: ${Gotham};
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
  letter-spacing: 2px;
  line-height: 20px;
`;

export const BottomLayer = styled('span')`
  display: block;
  position: relative;
  background-color: ${(props: ButtonProps) => props.bottomColor};
  border: 1px solid ${(props: ButtonProps) => props.color};
  ${maxDimensions};
`;
